/*
 * @Description:挂靠
 * @Author: wangyuhan
 * @Date: 2022-03-11 17:34:31
 * @LastEditors: WangYuhan
 */
import { get, post, prefix } from './base';

// 根据id查询详情
export function getById(data) {
  return get(`${prefix}vehicle/affiliation/getById`, data);
}

// 分页查询
export function pageList(params) {
  return post(`${prefix}vehicle/affiliation/pageList`, params);
}

// 保存或者编辑
export function saveAndUpdate(params) {
  return post(`${prefix}vehicle/affiliation/saveAndUpdate`, params);
}

// 根据车牌查询挂靠关系
export function getProjectListByBid(params) {
  return get(`${prefix}vehicle/affiliation/getByVehicleNo`, params);
}
